/**
 * Update: 15/04/2024 - Mariam Bawa - update import statements as part of data type refactoring 
 */
import { GET_PREVIOUS_SNAPSHOT_DATA, RESET_GET_PREVIOUS_SNAPSHOT_DATA } from "../../actionTypes/actionsTypes"
import defaultAsyncReducer from "../../defaultReducer"
import { AppAction, LocalAction } from "../../types"
import { SnapshotState } from "./getFullSnapshotDataReducer"

export interface PreviousSnapshotState extends SnapshotState {
  found: boolean
}
const initialState: PreviousSnapshotState = {
  loading: false,
  error: false,
  success: false,
  message: "",
  data: {} as Record<string, unknown>,
  found: false
}

function getPreviousSnapshotDataReducer(state = initialState, action: AppAction | LocalAction) {
  if (action.type === RESET_GET_PREVIOUS_SNAPSHOT_DATA) {
    return initialState
  } else {
    return defaultAsyncReducer(state, action as AppAction, GET_PREVIOUS_SNAPSHOT_DATA)
  }
}

export default getPreviousSnapshotDataReducer